export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"

export const SOCIAL_LOGIN = "SOCIAL_LOGIN"

export const GOOGLE_SSO_LOGIN = "GOOGLE_SSO_LOGIN"
export const GOOGLE_SSO_LOGIN_SUCCESS = "GOOGLE_SSO_LOGIN_SUCCESS"
export const GOOGLE_SSO_LOGIN_ERROR = "GOOGLE_SSO_LOGIN_ERROR"
export const GOOGLE_SSO_SET_COOKIE = "GOOGLE_SSO_SET_COOKIE"
export const GOOGLE_SSO_SET_COOKIE_SUCCESS = "GOOGLE_SSO_SET_COOKIE_SUCCESS"
export const GOOGLE_SSO_SET_COOKIE_ERROR = "GOOGLE_SSO_SET_COOKIE_ERROR"
export const POST_SSO_ONLY_LOGIN_STATUS = "POST_SSO_ONLY_LOGIN_STATUS"
export const POST_SSO_ONLY_LOGIN_STATUS_SUCCESS = "POST_SSO_ONLY_LOGIN_STATUS_SUCCESS"
export const POST_SSO_ONLY_LOGIN_STATUS_ERROR = "POST_SSO_ONLY_LOGIN_STATUS_ERROR"

export const OKTA_SSO_LOGIN = "OKTA_SSO_LOGIN"
export const OKTA_SSO_LOGIN_SUCCESS = "OKTA_SSO_LOGIN_SUCCESS"
export const OKTA_SSO_LOGIN_ERROR = "OKTA_SSO_LOGIN_ERROR"

export const INITIATE_OKTA_LOGIN_FLOW = "INITIATE_OKTA_LOGIN_FLOW"
export const INITIATE_OKTA_LOGIN_FLOW_SUCCESS = "INITIATE_OKTA_LOGIN_FLOW_SUCCESS"
export const INITIATE_OKTA_LOGIN_FLOW_ERROR = "INITIATE_OKTA_LOGIN_FLOW_ERROR"
